// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4df76f6c","703":"b61dcc2b"}[chunkId] + ".chunk.js";
};